<template>
  <!--begin::Mixed Widget 1-->
  <div class="card card-custom bg-gray-100 card-stretch gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 bg-info py-1">
      <h3 class="card-title font-weight-bolder text-white">
        {{ $t('dashboard.user_status')}}
      </h3>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body p-0 position-relative overflow-hidden">
      <!--begin::Stats-->
      <div class="card-spacer p-1">
        <!--begin::Row-->
        <div class="row m-0">
          <div class="col">
            <div class="rounded-xl bg-danger mb-0 card px-2 py-8 pb-2">
              <span class="svg-icon svg-icon-3x svg-icon-danger d-block mt-2 mb-1">
                <span class="text-white font-weight-bolder h2"> 45 </span>
              </span>
              <a href="#" class="text-white font-weight-bold h6 mb-0">
              {{ $t('dashboard.user_customer_count')}}
              </a>
            </div>
          </div>
          <div class="col">
            <div class="rounded-xl bg-info mb-0 card px-2 py-8 pb-2">
              <span class="svg-icon svg-icon-3x svg-icon-danger d-block mt-2 mb-1">
                <span class="text-white font-weight-bolder h2"> 45 </span>
              </span>
              <a href="#" class="text-white font-weight-bold h6 mb-0">
              {{ $t('dashboard.user_technician_count')}}
              </a>
            </div>
          </div>
          <div class="col">
            <div class="rounded-xl bg-success mb-0 card px-2 py-8 pb-2">
              <span class="svg-icon svg-icon-3x svg-icon-danger d-block mt-2 mb-1">
                <span class="text-white font-weight-bolder h2"> 45 </span>
              </span>
              <a href="#" class="text-white font-weight-bold h6 mb-0">
              {{ $t('dashboard.user_operator_count')}}
              </a>
            </div>
          </div>
          <div class="col">
            <div class="rounded-xl bg-warning mb-0 card px-2 py-8 pb-2">
              <span class="svg-icon svg-icon-3x svg-icon-danger d-block mt-2 mb-1">
                <span class="text-white font-weight-bolder h2"> 45 </span>
              </span>
              <a href="#" class="text-white font-weight-bold h6 mb-0">
              {{ $t('dashboard.user_total_count')}}
              </a>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Stats-->
      <!--end::Body-->
    </div>
    <!--end::Mixed Widget 1-->
  </div>
</template>
<script>
import Dropdown1 from "@/view/content/dropdown/Dropdown1.vue";
import { mapGetters } from "vuex";

export default {
  name: "widget-1",
  components: {
    Dropdown1
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"])
  },
  mounted() {
  }
};
</script>